import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { ArrowsClockwise, Warning } from '@phosphor-icons/react';

export default function UpgradeRequired() {
  const [info, setInfo] = useState(null);
  const [release, setRelease] = useState(null);

  useEffect(() => {
    const base = process.env.REACT_APP_BACKEND_URL;
    axios.get(`${base}/api/app/version`).then(r => setInfo(r.data)).catch(() => setInfo({}));
    axios.get(`${base}/api/app/latest-release`).then(r => setRelease(r.data)).catch(() => setRelease(null));
  }, []);

  const handleHardRefresh = async () => {
    try {
      // Wipe service worker caches so the next reload pulls the new bundle.
      if ('caches' in window) {
        const keys = await caches.keys();
        await Promise.all(keys.map(k => caches.delete(k)));
      }
      if ('serviceWorker' in navigator) {
        const regs = await navigator.serviceWorker.getRegistrations();
        await Promise.all(regs.map(r => r.unregister()));
      }
    } catch {}
    window.location.reload(true);
  };

  return (
    <div
      className="min-h-screen flex items-center justify-center bg-[#0A0A0A] text-white px-6"
      data-testid="upgrade-required-page"
    >
      <div className="max-w-md w-full text-center space-y-6">
        <div className="inline-flex w-20 h-20 rounded-full bg-[#FF8C00]/10 items-center justify-center mx-auto">
          <Warning size={40} weight="bold" className="text-[#FF8C00]" />
        </div>
        <div>
          <p className="text-[10px] uppercase tracking-[0.25em] text-[#8E44AD] font-bold mb-2">Update Required</p>
          <h1 className="text-3xl font-black tracking-tight">App version no longer supported</h1>
          <p className="text-white/60 text-sm mt-3 leading-relaxed">
            This installed app is running an older version of Carloo and is no longer compatible
            with the server. Please install the latest APK to continue.
          </p>
        </div>

        {info && (
          <div className="bg-white/5 border border-white/10 px-4 py-3 text-sm space-y-1">
            <div className="flex justify-between">
              <span className="text-white/50">Required version</span>
              <span className="font-bold text-[#00C853]">{info.min_version || 'latest'}</span>
            </div>
            <div className="flex justify-between">
              <span className="text-white/50">Current server</span>
              <span className="font-mono">{info.current_version || '-'}</span>
            </div>
          </div>
        )}

        <div className="flex flex-col gap-3">
          {release?.available && release.download_url ? (
            <a
              href={`${process.env.REACT_APP_BACKEND_URL}${release.download_url}`}
              className="bg-[#002FA7] text-white px-6 py-3 font-bold uppercase tracking-widest text-sm hover:bg-[#002FA7]/90 transition-colors"
              data-testid="upgrade-download-btn"
              download="vehicle.apk"
            >
              Download v{release.version_name} APK
            </a>
          ) : info?.upgrade_url && (
            <a
              href={info.upgrade_url}
              className="bg-[#002FA7] text-white px-6 py-3 font-bold uppercase tracking-widest text-sm hover:bg-[#002FA7]/90 transition-colors"
              data-testid="upgrade-download-btn"
            >
              Download latest APK
            </a>
          )}
          <button
            onClick={handleHardRefresh}
            className="border border-white/20 text-white/80 px-6 py-3 font-bold uppercase tracking-widest text-sm hover:bg-white/5 transition-colors flex items-center justify-center gap-2"
            data-testid="upgrade-reload-btn"
          >
            <ArrowsClockwise size={16} /> Reload (PWA users)
          </button>
        </div>

        <p className="text-[11px] text-white/30 leading-relaxed">
          If you’re using the web version, the reload button will pull the latest build automatically.
          For the installed Android app, please download and reinstall the new APK from the link above.
        </p>
      </div>
    </div>
  );
}
